import type { TrackedTranslation } from '@ps/web-core-intl';
import type { InputProps } from '@ps/web-shared-components';
import { RawInput, Validation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';

import SearchIcon from '@swf/core/assets/icons/icon-search.svg';

import { root } from './SearchInput.scss';

const SearchInput: React.FC<InputProps> = ({ label, ...props }) => {
  const intl = useIntl();
  return (
    <RawInput
      {...props}
      autoComplete="off"
      validationVariant={Validation.Invisible}
      hideLabel
      placeholder={intl.formatMessage(label as TrackedTranslation)}
      label={label}
      className={root}
      icon={SearchIcon}
      startAdornment="icon"
    />
  );
};

export default SearchInput;
